import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Sort = forwardRef<IconProps, 'svg'>((props, ref) => {
  return (
    <Icon ref={ref} height="24" viewBox="0 0 24 24" width="24" {...props}>
      <path
        d="M7.68341 9.17991L11.6159 4.46093C11.8158 4.22105 12.1842 4.22106 12.3841 4.46093L16.3166 9.17991C16.588 9.50557 16.3564 10 15.9325 10H8.06752C7.6436 10 7.41203 9.50557 7.68341 9.17991Z"
        fill="currentColor"
      />
      <path
        d="M16.3166 14.8201L12.3841 19.5391C12.1842 19.7789 11.8158 19.7789 11.6159 19.5391L7.68341 14.8201C7.41203 14.4944 7.6436 14 8.06752 14L15.9325 14C16.3564 14 16.588 14.4944 16.3166 14.8201Z"
        fill="currentColor"
      />
    </Icon>
  );
});

export default Sort;
